import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

const Layout: React.FC = () => {
  return (
    <LayoutContainer>
      <MainContent>
        <Outlet />
      </MainContent>
      <Footer />
    </LayoutContainer>
  );
};

export default Layout; 